import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const BulkCreateRmasResultSchema_ = z.object({
  returnId: z.string(),
  status: z.enum(["created", "skipped", "error"]),
  message: z.string(),
});
export interface BulkCreateRmasResult extends z.infer<
  typeof BulkCreateRmasResultSchema_
> {}
export const BulkCreateRmasResultSchema: z.ZodType<BulkCreateRmasResult> =
  BulkCreateRmasResultSchema_;

export const bulkCreateRmas = unaryRpc({
  name: "bulkCreateRmas",
  input: z.object({ returnIds: z.array(z.string()) }),
  output: z.object({ results: z.array(BulkCreateRmasResultSchema) }),
});
